import { useContext, useEffect, useRef, useState } from 'react';
import Calendar from 'react-calendar';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';

import { Slots } from './Slot';
import { showNotification } from '@/utils/notificationUtils';
import {
  AppointmentData,
  AvailabilityRes,
  Business,
  CalendarUsers,
  Cost,
  Service,
  Slot,
} from '../types';
import { useGetAvailabilities, useGetBookedDates } from '../api/getAvailability';
import { useGetService } from '../api/getServices';
import { useGetCalenderUsers } from '../api/getCalenderUsers';

import UserIcon from '@/assets/img/v2/user-default-icon.png';
import DownArrow from '@/assets/img/down-arrow.svg';
import MeetingTimeIcon from '@/assets/img/time-icon.svg';

import './AppointmentServiceSelection.scss';
import { UserContext } from '@/components/Layout';
import Utils from '@/utils/util';
import { PetskedTitle } from '@/components/Heading/PetskedTitle';
import { DurationPicker } from './DurationPicker';
import { RangeDisplay } from './RangeDisplay';
import { useGetServiceCost } from '../api/getCost';
import { useTranslation } from 'react-i18next';
import { businessCurrency } from '@/features/Language/api/getCountryCurrency';
export type ApptServiceSelectionProps = {
  business?: Business;
  appointmentData?: AppointmentData;
  onChange: (appointmentData: AppointmentData) => void;
  next: (hasAddons: boolean) => void;
};

export const AppointmentServiceSelection = ({
  business,
  appointmentData,
  onChange,
  next,
}: ApptServiceSelectionProps) => {
  const userContext = useContext(UserContext);
  const inputRefService: any = useRef(null);
  const inputRefSubService: any = useRef(null);

  const [originalServiceProviders, setOriginalServiceProviders] = useState<CalendarUsers[]>([]);
  const [originalServices, setOriginalServices] = useState<Service[]>([]);
  const [hasAddons, setHasAddons] = useState<boolean>(false);

  const useGetAvailabilitiesMutation = useGetAvailabilities();
  const bookedDatesMutation = useGetBookedDates();

  const serviceQueryMutation = useGetService();
  const usersQueryMutation = useGetCalenderUsers();
  const serviceCostMutation = useGetServiceCost();
  const [slots, setSlots] = useState<Slot[]>();
  const [selectedSlot, setSelectedSlot] = useState<Slot | undefined>();
  const [serviceCost, setServiceCost] = useState<Cost>();
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [selectedDayRange, setSelectedDayRange] = useState<[Date, Date] | null>(null);

  const [availableSlots, setAvailableSlots] = useState<AvailabilityRes[]>();
  const [selectedService, setSelectedService] = useState<Service>();
  const [selectedSubService, setSelectedSubService] = useState<Service>();

  const [selectedProvider, setSelectedProvider] = useState<CalendarUsers>();
  const [selectedDuration, setSelectedDuration] = useState<number>(0);
  const [noOfPets, setNoOfPets] = useState<number>(1);

  //const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [serviceList, setServiceList] = useState<Service[]>();
  const [subServiceList, setSubServiceList] = useState<Service[]>();
  const [calenderUsers, setCalenderUsers] = useState<CalendarUsers[]>();
  const [alreadyBookedDates, setAlreadyBookedDates] = useState<any>([]);
  const [searchService, setSearchService] = useState<string>('');
  const [searchSubService, setSubSearchService] = useState<string>('');

  useEffect(() => {}, []);
  const handleServiceSearchChange = (e: any) => {
    setSearchService(e.target.value);
  };
  const handleSubServiceSearchChange = (e: any) => {
    setSubSearchService(e.target.value);
  };
  const onDropdownToggle = () => {
    if (inputRefService.current) {
      setTimeout(() => {
        inputRefService.current.focus();
      }, 500);
    }
    const scroller = document.getElementById('dd-menu-scroll-service');
    scroller?.scrollTo(0, 0);
    setSearchService('');
  };
  const onDropdownToggleSubservice = () => {
    if (inputRefSubService.current) {
      setTimeout(() => {
        inputRefSubService.current.focus();
      }, 500);
    }
    const scroller = document.getElementById('dd-menu-scroll-sservice');
    scroller?.scrollTo(0, 0);
    setSubSearchService('');
  };

  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const dataLoadedRef = useRef(false);

  useEffect(() => {
    if (appointmentData?.selectedLocation) {
      dataLoadedRef.current = false;
      setSelectedService(undefined);
      setSelectedSubService(undefined);
      setSelectedProvider(undefined);
      setSelectedDuration(0);
      setAlreadyBookedDates([]);
      setCalenderUsers([]);
      setNoOfPets(1);
      setAvailableSlots(undefined);
      setSelectedDayRange(null);
      setSelectedSlot(undefined);
      setServiceCost(undefined);
      setSelectedDate(undefined);
      setHasAddons(false);
      setTimeout(() => {
        initializeData();
      }, 500);
    }
  }, [appointmentData?.selectedLocation]);
  useEffect(() => {
    if (dataLoadedRef.current) {
      onDataChange();
    }
  }, [hasAddons]);

  useEffect(() => {
    if (dataLoadedRef.current) {
      checkBoardingCost(noOfPets);
    }
  }, [selectedDayRange]);

  // useEffect(() => {
  //   if(appointmentData && appointmentData.service) {
  //     if(appointmentData.service.parentServiceId) {
  //       if(originalServiceProviders.length && originalServices.length && subServiceList?.length) {
  //         setDataLoaded(true);
  //         checkAndUpdate();
  //       }
  //     } else {
  //       if(originalServiceProviders.length && originalServices.length) {
  //         setDataLoaded(true);
  //         checkAndUpdate();
  //       }
  //     }
  //   }
  // }, [originalServices, originalServiceProviders, subServiceList]);

  const { t } = useTranslation();
  useEffect(() => {
    if (!dataLoadedRef.current) {
      if (appointmentData && appointmentData.service) {
        if (appointmentData.service.parentServiceId) {
          if (
            originalServiceProviders.length &&
            originalServices.length &&
            calenderUsers?.length &&
            serviceList?.length &&
            subServiceList?.length
          ) {
            checkAndUpdate();
          }
        } else {
          if (
            originalServiceProviders.length &&
            originalServices.length &&
            calenderUsers?.length &&
            serviceList?.length
          ) {
            checkAndUpdate();
          }
        }
      }
    }
  }, [originalServiceProviders, originalServices, calenderUsers, serviceList, subServiceList]);

  useEffect(() => {
    const slots: Slot[] = [];
    if (availableSlots) {
      availableSlots.map((item: any, index: number) => {
        let formatedDate;

        if (appointmentData?.selectedLocation?.timezone) {
          formatedDate = moment(item.start)
            .tz(appointmentData?.selectedLocation?.timezone)
            .format('hh:mm A');
        } else {
          formatedDate = moment(item.start).format('hh:mm A');
        }

        if (formatedDate.indexOf('PM') > 0) {
          slots.push({ ...item, label: formatedDate, id: index });
        } else {
          slots.push({ ...item, label: formatedDate, id: index });
        }
      });
    }

    setSlots(slots);
  }, [availableSlots]);
  useEffect(() => {
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) {
      if (dataLoadedRef.current) {
        onDataChange();
        getAvailabilitySlots(selectedDate);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, selectedService, selectedProvider, selectedSubService]);
  useEffect(() => {
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) {
      if (dataLoadedRef.current && selectedDate) {
        setSelectedSlot(undefined);
        onDataChange();
        getAvailabilitySlots(selectedDate);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, selectedDuration]);
  useEffect(() => {
    if (dataLoadedRef.current) {
      onDataChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSlot, serviceCost, noOfPets]);

  useEffect(() => {
    if (serviceList && selectedSubService && !selectedService) {
      const fs: Service | undefined = serviceList.find(
        (sl) => sl.id === selectedSubService.parentServiceId
      );
      if (fs) {
        setSelectedService(fs);
        getServices(business?.id, fs.id);
      }
    }
  }, [serviceList]);
  const initializeData = () => {
    Utils.scrollToTop();
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) {
      if (appointmentData?.service) {
        dataLoadedRef.current = false;
      } else {
        dataLoadedRef.current = true;
        setSelectedDate(
          Utils.fromServerTz(new Date(), appointmentData?.selectedLocation?.timezone)
        );
      }
      getServices(business?.id);
      return;
    }
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING) {
      dataLoadedRef.current = true;
      if (appointmentData && appointmentData.startDate && appointmentData.endDate) {
        setSelectedDayRange([appointmentData.startDate, appointmentData.endDate]);
        getRoomBookedDates(appointmentData.startDate);
        setNoOfPets(appointmentData?.noOfPets ? appointmentData?.noOfPets : 1);
      } else {
        getRoomBookedDates(new Date());
      }
    }
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) {
      dataLoadedRef.current = true;
      appointmentData.slot && setSelectedSlot(appointmentData.slot);
      setSelectedDuration(appointmentData.duration ? appointmentData.duration : 60);
      setNoOfPets(appointmentData?.noOfPets ? appointmentData?.noOfPets : 1);
      if (appointmentData.date) {
        setSelectedDate(appointmentData.date);
      } else {
        setSelectedDate(
          Utils.fromServerTz(new Date(), appointmentData?.selectedLocation?.timezone)
        );
      }
    }
  };
  const checkDayCareCost = async (slotData: Slot, duration: number, petCount: number) => {
    try {
      const res = await serviceCostMutation.mutateAsync({
        data: {
          duration: duration,
          startTime: slotData.start,
          petCount: petCount,
        },
        serviceType: appointmentData?.selectedServiceType,
      });
      setServiceCost(res);
    } catch (e) {
      Utils.scrollToTop();
      setSelectedSlot(undefined);
      setNoOfPets(1);
    }
  };
  const checkBoardingCost = async (petCount: number) => {
    if (selectedDayRange && selectedDayRange.length == 2) {
      try {
        const res = await serviceCostMutation.mutateAsync({
          data: {
            startDate: moment(selectedDayRange[0]).format('YYYY-MM-DD'),
            endDate: moment(selectedDayRange[1]).format('YYYY-MM-DD'),
            petCount: petCount,
          },
          serviceType: appointmentData?.selectedServiceType,
        });
        setServiceCost(res);
      } catch (e) {
        setNoOfPets(1);
        setSelectedDayRange(null);
      }
    }
  };
  const getServices = async (id?: string, parent?: string) => {
    const res = await serviceQueryMutation.mutateAsync({
      businessId: Number(id),
      headers: {
        'loc-id': appointmentData?.selectedLocation?.id,
      },
      parent,
      active: true,
    });
    if (!parent) {
      setOriginalServices(res.list);
      const filteredService = getServiceAlone(res.list);
      if (res.list.find((service) => service.isAddonService === true)) {
        setHasAddons(true);
      }
      setServiceList(filteredService);
      // if ( res.list && res.list.length == 1) {
      //   setSelectedDuration(res.list[0].duration);
      //   setSelectedService(res.list[0]);
      //   getAvailabilitySlots();
      // }
      getCalenderUsers(business?.id);
      if (!dataLoadedRef.current && appointmentData && appointmentData.service) {
        getServices(
          business?.id,
          appointmentData.service.parentServiceId
            ? appointmentData.service.parentServiceId
            : appointmentData.service.id
        );
      }
    } else {
      const filteredService = getServiceAlone(res.list);
      setSubServiceList(filteredService);
      // setSelectedDuration(0);
    }
  };
  const getServiceAlone = (list: Service[]) => {
    return list.filter((service: Service) => !service.isAddonService);
  };
  const getCalenderUsers = async (id?: string) => {
    const res = await usersQueryMutation.mutateAsync({
      id: Number(id),
    });
    setOriginalServiceProviders([...res.list]);
    setCalenderUsers(res.list);
    if (!dataLoadedRef.current && appointmentData && appointmentData.service) {
      if (appointmentData.service.parentServiceId) {
        getServices(business?.id, appointmentData.service.parentServiceId);
      }
    }
  };
  const checkAndUpdate = () => {
    if (!dataLoadedRef.current && appointmentData) {
      appointmentData.date
        ? setSelectedDate(
            Utils.fromServerTz(appointmentData.date, appointmentData?.selectedLocation?.timezone)
          )
        : setSelectedDate(
            Utils.fromServerTz(new Date(), appointmentData?.selectedLocation?.timezone)
          );
      appointmentData.slot && setSelectedSlot(appointmentData.slot);
      const duration = Utils.getDurationFromService(appointmentData.service);
      setSelectedDuration(duration);
      if (appointmentData.provider) {
        setSelectedProvider(appointmentData.provider);
        onProviderSelect(appointmentData.provider, true);
      }
      setTimeout(() => {
        if (appointmentData.service) {
          if (appointmentData.service.parentServiceId) {
            const mainService = originalServices.find(
              (os) => os.id === appointmentData.service?.parentServiceId
            );
            if (mainService) {
              setSelectedService(mainService);
              onServiceSelect(mainService, true);
            }
            setTimeout(() => {
              setSelectedSubService(appointmentData.service);
              appointmentData?.service && onSubServiceSelect(appointmentData?.service, true);
            }, 0);
          } else {
            setSelectedService(appointmentData.service);
            onServiceSelect(appointmentData.service, true);
            getAvailabilitySlots(appointmentData.date);
          }
        }

        dataLoadedRef.current = true;
      }, 0);
    }
  };
  const onRangeChange = (dates: [Date, Date]) => {
    if (Array.isArray(dates)) {
      setSelectedDayRange(dates);
      setServiceCost(undefined);
      if (appointmentData) {
        appointmentData.startDate = dates[0];
        appointmentData.endDate = dates[1];
        onChange(appointmentData);
      }
    }
  };
  const onDateChange = (date: Date) => {
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) {
      if (!selectedService) {
        showNotification({
          type: 'info',
          title: t('Please select service and try again.'),
        });
        return;
      }
      setSelectedDate(date);
      setSelectedSlot(undefined);
      getAvailabilitySlots(date);
    }
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) {
      setSelectedDate(date);
      setServiceCost(undefined);
      setSelectedSlot(undefined);
      getAvailabilitySlots(date);
    }
  };

  const getAvailabilitySlots = async (date?: Date) => {
    const selectedDate = date ? date : new Date();
    //setSelectedSlot(undefined);
    if (
      !business ||
      !business.id ||
      useGetAvailabilitiesMutation.isLoading ||
      selectedDuration == 0
    ) {
      return;
    }
    if (business) {
      const res = await useGetAvailabilitiesMutation.mutateAsync({
        data: {
          businessId: Number(business?.id),
          duration: selectedDuration,
          date: Utils.toServerTz(selectedDate, appointmentData?.selectedLocation?.timezone),
          tz: moment.tz.guess(true),
          userId: Number(selectedProvider?.id),
          serviceId: Number(selectedService?.id),
          serviceType: appointmentData?.selectedServiceType,
        },
      });
      setAvailableSlots(res);
    }
  };
  const onSlotSelected = async (data: any) => {
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) {
      if (!selectedProvider) {
        if (data && data.users && data.users[0]) {
          //setSelectedProvider(data.users[0]);
          onProviderSelect(data.users[0]);
          setSelectedSlot({ ...data });
        }
      } else {
        setSelectedSlot({ ...data });
      }
      onDataChange();
    } else {
      setSelectedSlot({ ...data });
      checkDayCareCost(data, selectedDuration, noOfPets);
    }
  };
  const onProviderSelect = (item: CalendarUsers, updateListAlone = false) => {
    const tmp =
      calenderUsers &&
      calenderUsers.map((el) =>
        el.id == item.id ? { ...el, selected: !item.selected } : { ...el, selected: false }
      );

    setCalenderUsers(tmp);
    const services = getServiceListBySp(item);
    let serviceMatchFound = false;
    services?.forEach((element) => {
      if (selectedService && element.id === selectedService.id) {
        element.selected = true;
        serviceMatchFound = true;
      } else {
        element.selected = false;
      }
    });
    if (!updateListAlone) {
      if (item.selected) {
        resetServiceProvider();
        return;
      } else {
        setSelectedProvider(item);
      }
      if (!serviceMatchFound) {
        setSelectedService(undefined);
      }
      setSelectedSlot(undefined);
    }
    //setSelectedSlot(undefined);
    if (services?.find((service) => service.isAddonService)) {
      setHasAddons(true);
    } else {
      setHasAddons(false);
    }
    const filteredService = services && getServiceAlone([...services]);
    services && setServiceList(filteredService);
  };
  const onServiceSelect = (item: Service, updateListAlone = false) => {
    const tmp =
      serviceList &&
      serviceList.map((el) =>
        el.id == item.id
          ? { ...el, selected: updateListAlone ? true : !item.selected }
          : { ...el, selected: false }
      );
    setServiceList(tmp);

    const serviceProviders = getServiceProvidersByService(item);
    let spMatchFound = false;
    serviceProviders?.forEach((element) => {
      if (selectedProvider && element.id === selectedProvider.id) {
        element.selected = true;
        spMatchFound = true;
      } else {
        element.selected = false;
      }
    });

    if (!updateListAlone) {
      if (item.selected) {
        resetService();
        return;
      } else {
        if (selectedService && item.id != selectedService.id) {
          resetService();
        }
        setSelectedService(item);
      }
      setSelectedDuration(Utils.getDurationFromService(item));
      if (!spMatchFound) {
        setSelectedProvider(undefined);
      }

      setSelectedSlot(undefined);
      getServices(business?.id, item?.id);
    }
    serviceProviders && setCalenderUsers([...serviceProviders]);
  };
  const onSubServiceSelect = (item: Service, updateListAlone = false) => {
    const tmp =
      subServiceList &&
      subServiceList.map((el) =>
        el.id == item.id
          ? { ...el, selected: updateListAlone ? true : !item.selected }
          : { ...el, selected: false }
      );
    setSubServiceList(tmp);

    if (!updateListAlone) {
      if (item.selected) {
        resetSubService();
        return;
      } else {
        setSelectedSubService(item);
      }
      setSelectedDuration(Utils.getDurationFromService(item));
      setSelectedSlot(undefined);
    }
  };
  const getServiceListBySp = (serviceProvider: CalendarUsers) => {
    const sp = originalServiceProviders?.find((cu) => cu.id === serviceProvider.id);
    return sp?.services;
  };
  const getServiceProvidersByService = (service: Service) => {
    const ss = originalServices?.find((sl) => sl.id === service.id);
    return ss && ss.businessUsers;
  };

  const validate = () => {
    let errorMessage = '';
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING) {
      if (!selectedService) {
        errorMessage = t('Please select service type.');
      } else if (!selectedProvider) {
        errorMessage = t('Please select provider.');
      } else if (!selectedDate) {
        errorMessage = t('Please select appointment date.');
      } else if (!selectedSlot) {
        errorMessage = t('Please select time slot.');
      }
    } else if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING) {
      if (!selectedDayRange || (selectedDayRange && selectedDayRange.length < 2)) {
        errorMessage = t('Please select booking dates.');
      } else if (
        selectedDayRange &&
        selectedDayRange.length === 2 &&
        moment(selectedDayRange[0]).format('YYYY-MM-DD') ===
          moment(selectedDayRange[1]).format('YYYY-MM-DD')
      ) {
        errorMessage = t('Please select valid date range to complete the booking.');
      } else if (!appointmentData.cost) {
        errorMessage = t(
          'Rooms not available for the current selection , please select different dates.'
        );
      }
    } else if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) {
      if (!selectedDate) {
        errorMessage = t('Please select booking date.');
      } else if (!selectedSlot) {
        errorMessage = t('Please select time slot.');
      } else if (!appointmentData.cost) {
        errorMessage = t(
          'Rooms not available for the current selection , please select different dates.'
        );
      }
    }
    if (errorMessage) {
      showNotification({
        type: 'info',
        title: errorMessage,
      });
      return false;
    }
    return true;
  };
  const onNextClick = () => {
    const isValid = validate();

    if (isValid) {
      next(hasAddons);
    }
  };
  const onDataChange = () => {
    const updatedAddons: Service[] = [];
    if (selectedProvider) {
      const services = getServiceListBySp(selectedProvider);
      if (appointmentData?.selectedAddons) {
        appointmentData?.selectedAddons.forEach((sa) => {
          const availableAddon = services?.find((service) => service.id === sa.id);
          if (availableAddon) {
            updatedAddons.push(availableAddon);
          }
        });
      }
    }

    const updatedData = {
      ...appointmentData,
      service: selectedSubService ? selectedSubService : selectedService,
      provider: selectedProvider,
      slot: selectedSlot,
      date: selectedDate,
      duration: selectedDuration,
      tz: appointmentData?.tz ? appointmentData?.tz : tz,
      addonsAvailable: hasAddons,
      selectedAddons: updatedAddons,
      cost: serviceCost,
      noOfPets: noOfPets,
    };
    onChange(updatedData);
  };

  const resetServiceProvider = () => {
    setSelectedProvider(undefined);
    setHasAddons(false);
    const sl = [...originalServices];
    sl.forEach((service) => {
      if (selectedService && service.id === selectedService.id) {
        service.selected = true;
      } else {
        service.selected = false;
      }
    });
    setServiceList(sl);
    setSelectedSlot(undefined);
  };
  const resetService = () => {
    setSelectedService(undefined);
    setSelectedSubService(undefined);
    setSubServiceList([]);
    const sps = [...originalServiceProviders];
    sps.forEach((osp) => {
      if (selectedProvider && osp.id === selectedProvider.id) {
        osp.selected = true;
      } else {
        osp.selected = false;
      }
    });
    setCalenderUsers(sps);
    setSelectedSlot(undefined);
  };
  const resetSubService = () => {
    setSelectedSubService(undefined);
    setSelectedSlot(undefined);
    setSelectedDuration(Utils.getDurationFromService(selectedService));
  };
  const onCalendarNav = (startDate: Date) => {
    getRoomBookedDates(startDate);
  };
  const getRoomBookedDates = async (date: Date) => {
    const startDate = moment(date).startOf('month').startOf('week').format('YYYY-MM-DD');
    const endDate = moment(date).endOf('month').endOf('week').format('YYYY-MM-DD');
    const res = await bookedDatesMutation.mutateAsync({
      data: {
        startDate,
        endDate,
      },
    });
    if (res) {
      setAlreadyBookedDates(res?.busyDays);
    }
  };
  const getTileClassName = ({ date }: { date: Date }) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    if (alreadyBookedDates.includes(formattedDate)) {
      return 'range-picker booked';
    }
    return 'range-picker';
  };
  const onDurationChange = (value: number) => {
    setServiceCost(undefined);
    setSelectedDuration(value);
  };
  const onNoOfPetsChange = (value: number) => {
    setNoOfPets(value);
    if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE) {
      selectedSlot && checkDayCareCost(selectedSlot, selectedDuration, value);
    } else if (appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING) {
      checkBoardingCost(value);
    }
  };

  const filteredServiceList = serviceList?.filter(
    (d) => d?.name?.toLowerCase().indexOf(searchService.toLowerCase()) >= 0
  );
  const filteredSubServiceList = subServiceList?.filter(
    (d) => d?.name?.toLowerCase().indexOf(searchSubService.toLowerCase()) >= 0
  );

  return (
    <div className={`slot-selection ${appointmentData?.selectedServiceType}`}>
      <div>
        {appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.GROOMING ? (
          <div className="details-select">
            {userContext?.isLandscape ? (
              <div className="top">
                <label>
                  {!userContext?.isLandscape
                    ? t('Service and Provider')
                    : t('Select provider first followed by services')}
                </label>
                <Dropdown key={'service-provider-dr'} className="white">
                  <Dropdown.Toggle>
                    {selectedProvider ? (
                      <div className="selected-service-provider">
                        <img
                          src={selectedProvider?.avatarUrl ? selectedProvider.avatarUrl : UserIcon}
                        />
                        <span>{selectedProvider?.name}</span>
                      </div>
                    ) : (
                      <div className="dropdown-placeholder">{t('Serviced By')}</div>
                    )}

                    {/* <RedCross className="red-cross" onClick={resetServiceProvider} /> */}
                    <img src={DownArrow} className="down-arrow" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="Duration-drop-down">
                    {calenderUsers &&
                      calenderUsers?.map((item) => {
                        return (
                          <Dropdown.Item
                            className={`${item.selected ? 'selected' : ''}`}
                            key={item.id}
                            onClick={() => onProviderSelect(item)}
                          >
                            <div className="service-provider-item">
                              <img src={item?.avatarUrl ? item?.avatarUrl : UserIcon} />{' '}
                              <span>{item.name}</span>
                            </div>
                          </Dropdown.Item>
                        );
                      })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            ) : (
              <div className="service-providers">
                <label>{t('Select provider first followed by services')}</label>
              </div>
            )}
            <div className="dropdown-selectors">
              <div className="service-list">
                {!userContext?.isLandscape && (
                  <>
                    <label>{t('Select provider')}</label>
                    <Dropdown key={'service-provider-dr'} className="white">
                      <Dropdown.Toggle>
                        {selectedProvider ? (
                          <div className="selected-service-provider">
                            <img
                              src={
                                selectedProvider?.avatarUrl ? selectedProvider?.avatarUrl : UserIcon
                              }
                            />
                            <span>{selectedProvider?.name}</span>
                          </div>
                        ) : (
                          <div className="dropdown-placeholder">{t('Serviced By')}</div>
                        )}

                        {/* <RedCross className="red-cross" onClick={resetServiceProvider} /> */}
                        <img src={DownArrow} className="down-arrow" />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="Duration-drop-down">
                        {calenderUsers &&
                          calenderUsers?.map((item) => {
                            return (
                              <Dropdown.Item
                                className={`${item.selected ? 'selected' : ''}`}
                                key={item.id}
                                onClick={() => onProviderSelect(item)}
                              >
                                <div className="service-provider-item">
                                  <img src={item?.avatarUrl ? item?.avatarUrl : UserIcon} />{' '}
                                  <span>{item.name}</span>
                                </div>
                              </Dropdown.Item>
                            );
                          })}
                      </Dropdown.Menu>
                    </Dropdown>
                    <label>{t('Select service')}</label>
                  </>
                )}

                <Dropdown key={'service-list-dr'} onToggle={onDropdownToggle}>
                  <Dropdown.Toggle>
                    {selectedService?.name ? (
                      selectedService?.name
                    ) : (
                      <span className="dropdown-placeholder">{t('Select service')}</span>
                    )}
                    {/* <RedCross className="red-cross" onClick={resetService} /> */}

                    <img src={DownArrow} className="down-arrow" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <div
                      className="dropdown-item petsked-form search"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <input
                        ref={inputRefService}
                        type="text"
                        className="form-control mb-2"
                        placeholder="Search..."
                        value={searchService}
                        autoFocus
                        onChange={handleServiceSearchChange}
                      />
                    </div>
                    <div id="dd-menu-scroll-sservice " className="menu-scroller">
                      {filteredServiceList &&
                        filteredServiceList?.map((item) => {
                          return (
                            <Dropdown.Item
                              className={`${item.selected ? 'selected' : ''}`}
                              key={item.id}
                              onClick={() => onServiceSelect(item)}
                            >
                              <div
                                className="service-item"
                                title={`${item.name}  ${
                                  item.price > 0 ? '($' + item.price + ')' : ''
                                }`}
                              >
                                <span>{`${item.name}`} </span>{' '}
                                <span>{`(${Utils.getDefaultPriceFromService(
                                  item,
                                  t,
                                  businessCurrency(business, 'USD')
                                )})`}</span>
                              </div>
                            </Dropdown.Item>
                          );
                        })}
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                {subServiceList && subServiceList.length > 0 && (
                  <Dropdown
                    className="sub-service"
                    key={'service-sub-list-dr'}
                    onToggle={onDropdownToggleSubservice}
                  >
                    <Dropdown.Toggle>
                      {selectedSubService?.name ? (
                        selectedSubService?.name
                      ) : (
                        <span className="dropdown-placeholder">{t('Select sub service')}</span>
                      )}
                      {/* <RedCross className="red-cross" onClick={resetSubService} /> */}

                      <img src={DownArrow} className="down-arrow" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <div
                        className="dropdown-item petsked-form search"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <input
                          ref={inputRefSubService}
                          type="text"
                          className="form-control mb-2"
                          placeholder="Search..."
                          value={searchSubService}
                          autoFocus
                          onChange={handleSubServiceSearchChange}
                        />
                      </div>
                      <div id="dd-menu-scroll-sservice" className="menu-scroller">
                        {filteredSubServiceList?.map((item) => {
                          return (
                            <Dropdown.Item
                              className={`${item.selected ? 'selected' : ''}`}
                              key={item.id}
                              onClick={() => onSubServiceSelect(item)}
                            >
                              <div
                                className="service-item"
                                title={`${item.name}  ${
                                  item.price > 0 ? '($' + item.price + ')' : ''
                                }`}
                              >
                                <span>{`${item.name}`} </span>{' '}
                                <span>{`(${Utils.getDefaultPriceFromService(
                                  item,
                                  t,
                                  businessCurrency(business, 'USD')
                                )})`}</span>
                              </div>
                            </Dropdown.Item>
                          );
                        })}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
              {/* <div className="service-providers">
              {!userContext?.isLandscape && (
                <>
                  <label>Select service providers</label>
                </>
              )}
              
            </div> */}
            </div>
          </div>
        ) : (
          <div className="details-select">
            <div className="top">
              <label>{t('Select date and available slots')}</label>
            </div>
          </div>
        )}
        <div className="meeting-slot">
          {!userContext?.isLandscape && (
            <>
              <label>{t('Date and time')}</label>
            </>
          )}
          {!userContext?.isLandscape && (
            <>
              <label className="selected-date tz" style={{ textAlign: 'left' }}>
                Timezone:{' '}
                <span>{Utils.getDetailedTz(appointmentData?.selectedLocation?.timezone)}</span>
              </label>
            </>
          )}
          <div>
            {appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.BOARDING ? (
              <>
                <Calendar
                  value={selectedDayRange}
                  selectRange={true}
                  minDate={Utils.fromServerTz(
                    new Date(),
                    appointmentData?.selectedLocation?.timezone
                  )}
                  onChange={onRangeChange}
                  onActiveStartDateChange={(data: any) => onCalendarNav(data.activeStartDate)}
                  tileClassName={getTileClassName}
                />
                {selectedDayRange &&
                  selectedDayRange.length === 2 &&
                  moment(selectedDayRange[0]).format('YYYY-MM-DD') !==
                    moment(selectedDayRange[1]).format('YYYY-MM-DD') && (
                    <RangeDisplay
                      business={business}
                      startDate={selectedDayRange[0]}
                      endDate={selectedDayRange[1]}
                      appointmentData={appointmentData}
                    />
                  )}
              </>
            ) : (
              <Calendar
                tileClassName={'date-picker'}
                value={selectedDate}
                selectRange={false}
                minDate={Utils.fromServerTz(
                  new Date(),
                  appointmentData?.selectedLocation?.timezone
                )}
                onChange={onDateChange}
              />
            )}
            {!userContext?.isLandscape && (
              <>
                <hr className="duration-hr" />
              </>
            )}
            {appointmentData?.selectedServiceType === Utils.SERVICE_TYPES.DAY_CARE && (
              <div className="duration-container">
                <PetskedTitle
                  title={t('Daycare duration')}
                  size="sm"
                  description={t('Select the duration of your daycare service')}
                />
                <DurationPicker
                  selectedDuration={selectedDuration}
                  onSelectDuration={(item) => {
                    onDurationChange(item);
                  }}
                  disableConversion={false}
                  defaultValues={{ step: 30, maxHours: 600 }}
                  disabled={serviceCostMutation.isLoading}
                />
              </div>
            )}
            {appointmentData?.selectedServiceType !== Utils.SERVICE_TYPES.GROOMING && (
              <div className="duration-container noofpets">
                <PetskedTitle
                  title="No of pets"
                  size="sm"
                  description="Select the no of pet for the booking"
                />
                <DurationPicker
                  selectedDuration={noOfPets}
                  onSelectDuration={(item) => {
                    onNoOfPetsChange(item);
                  }}
                  defaultValues={{ step: 1, maxHours: 5 }}
                  disableConversion={true}
                />
              </div>
            )}
          </div>
          {!userContext?.isLandscape && (
            <>
              <hr />
            </>
          )}

          <div className="slots-section slot-container">
            {appointmentData?.selectedServiceType != Utils.SERVICE_TYPES.BOARDING ? (
              <span className="date-info">
                <p className="selected-date">{moment(selectedDate).format('dddd, DD MMM')}</p>
                {!userContext?.isLandscape && (
                  <>
                    {selectedDuration > 0 && (
                      <span className="duration">
                        <img src={MeetingTimeIcon} />
                        {Utils.minutesToDhm(selectedDuration)}
                      </span>
                    )}
                  </>
                )}
              </span>
            ) : (
              <>
                <span className="date-info">
                  <p className="selected-date">{t('Check-In Time')}</p>
                </span>
                <div>
                  <div className="slots">
                    <div className="slot active">
                      {Utils.getTimeLabel(appointmentData?.selectedLocation?.boardingCheckIn)}
                    </div>
                  </div>
                </div>
              </>
            )}
            {appointmentData?.selectedServiceType != Utils.SERVICE_TYPES.BOARDING && (
              <Slots
                title="am slots"
                slots={slots}
                onSelectSlot={onSlotSelected}
                selectedSlot={selectedSlot}
                isLoading={useGetAvailabilitiesMutation.isLoading}
              />
            )}
          </div>
        </div>
      </div>
      <div className="action">
        <button
          className="petsked-button button-dark"
          onClick={onNextClick}
          disabled={serviceCostMutation.isLoading}
        >
          {t('Continue')}
        </button>
      </div>
    </div>
  );
};

AppointmentServiceSelection.displayName = 'BusinessMeeting';
